import React, {useEffect, useState} from 'react';
import LocationReportListSingle from './LocationReportListSingle';
import api from '../../../../api/axios';
import Cookies from 'js-cookie';
import {useDatePickerStore} from '../DatepickerStore'; // Importiere den Datepicker Store
import {format} from 'date-fns';

const LocationReportList = () => {
    const [colors, setColors] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const startDate = useDatePickerStore((state) => state.startDate); // Verwende den Datepicker Store
    const endDate = useDatePickerStore((state) => state.endDate);

    useEffect(() => {
        const getCSSBackgroundColor = (className) => {
            const element = document.createElement('div');
            element.className = className;
            document.body.appendChild(element);
            const bgColor = window.getComputedStyle(element).backgroundColor;
            document.body.removeChild(element);
            return bgColor;
        };

        // Farben manuell aus den CSS-Klassen holen
        const color1 = getCSSBackgroundColor('bg-color-1');
        const color2 = getCSSBackgroundColor('bg-color-4');
        const color3 = getCSSBackgroundColor('bg-color-6');
        setColors([color1, color2, color3]);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null); // Reset error state before fetching
            try {
                // Datum formatieren
                const formattedStartDate = format(startDate, 'yyyy-MM-dd');
                const formattedEndDate = format(endDate, 'yyyy-MM-dd');

                // Access Token aus Cookies abrufen
                const accessToken = Cookies.get('accessToken');
                if (!accessToken) {
                    throw new Error('Access Token fehlt. Bitte melden Sie sich erneut an.');
                }

                // Anfrage mit Authorization-Header durchführen
                const response = await api.get(
                    `/api/v1/companysite?start=${formattedStartDate}&end=${formattedEndDate}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                const {companySites} = response.data;

                // Für jeden Standort die Summen berechnen
                const formattedData = Object.entries(companySites).map(([siteName, periods]) => {
                    let totalRevenue = 0;
                    let totalCosts = 0;
                    let totalYield = 0;

                    // Iteriere über alle Zeiträume und summiere die Werte
                    Object.values(periods).forEach((period) => {
                        totalRevenue += parseFloat(period.revenue);
                        totalCosts += parseFloat(period.costs);
                        totalYield += parseFloat(period.yield);
                    });

                    return {
                        name: siteName,
                        revenue: totalRevenue,
                        costs: totalCosts,
                        yield: totalYield,
                    };
                });

                setData(formattedData);
            } catch (err) {
                console.error('Fehler beim Abrufen der Daten:', err);
                setError(err.message || 'Unbekannter Fehler');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [startDate, endDate]);

    return (
        <div className='flex flex-col justify-between w-full mt-2'>
            {loading && <p>Laden...</p>}
            {error && <p>Fehler: {error}</p>}
            {!loading && !error && data.map((project, index) => (
                <div key={index} className='flex items-center'>
                    {/* Farbiger Punkt */}
                    <div className={`w-2 h-2 mr-2 rounded-full`}
                         style={{backgroundColor: colors[index % colors.length]}}></div>
                    <LocationReportListSingle
                        company={project.name}
                        revenue={`${project.revenue.toLocaleString('de-DE')} €`} // Formatierung der Umsätze
                        isLast={index === data.length - 1}
                    />
                </div>
            ))}
        </div>
    );
}

export default LocationReportList;
